/**
 *  @class
 *  @function Pagination
 */

if (!customElements.get('pagination')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.button = this.querySelector('.load-more');
      this.grid = document.querySelector('[data-id=' + id + ']');
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      this.i = parseInt(this.getAttribute('data-current-page'), 10) + 1;
    }
    connectedCallback() {
      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }
    }
    addUrlParam(search, key) {
      var newParam = key + '=' + this.i,
        params = '?' + newParam;

      // If the "search" string exists, then build params from it
      if (search) {
        // Try to replace an existance instance
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);

        // If nothing was replaced, then add the new param to the end
        if (params === search) {
          params += '&' + newParam;
        }
      }

      return params;
    }
   attachKlaviyoClickHandlers() {
     const collection_main = document.querySelector('#product-grid');
    const klaviyo_buttons = collection_main.querySelectorAll('.notifyme_btn');
    klaviyo_buttons.forEach(button => button && button.addEventListener('click', function (e) {
      e.preventDefault();
      const handle = button.getAttribute('data-product-handle');
      const triggerElement = document.querySelector(`#klaviyo-data-handle-${handle} .klaviyo-bis-trigger`);
      if (triggerElement) {
        triggerElement.click();
      } else {
        console.error("Klaviyo trigger element not found!");
      }
    }));
  }
    loadMore() {
      let base = this;
      let max = parseInt(base.getAttribute('data-size'), 10);
      let curent = parseInt(this.getAttribute('data-current-page'), 10);
      this.button.addEventListener('click', function() {
         let url = document.location.pathname + base.addUrlParam(document.location.search, 'page');
             console.log("Base_url: " + document.location.pathname);
          console.log("Base_url: " +  base.addUrlParam(document.location.search, 'page'));
        base.loadProducts();
        if(curent < max) {
                  base.updateCollectionUrl(url);
        }
        this.blur();
        return false;
      });
    }
    infinite() {
      let base = this;
    
      base.observer = new IntersectionObserver(function(entries) {
        if (entries[0].intersectionRatio === 1) {
          base.loadProducts();
        }
      }, {
        threshold: [0, 1]
      });
      base.observer.observe(base);
    }
    updateCollectionUrl(url) {
        window.history.replaceState({}, '', `${url}`);
    }
    loadProducts() {
      let base = this,
        url = document.location.pathname + base.addUrlParam(document.location.search, 'page');
      if (base.getAttribute('loading')) {
        return;
      }
       const size = parseInt(base.getAttribute('data-size'));
      base.i++;
    
      base.setAttribute('loading', true);
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;
          base.renderProducts(html, url);

          dispatchCustomEvent('pagination:page-changed', {
            url: url
          });
            base.attachKlaviyoClickHandlers();
        });
    
        if(base.i > size) {
          base.style.display = 'none'
      }
    }
    renderProducts(html, url) {
      let base = this,
        grid_to_replace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');

      if (!grid_to_replace) {
        if (base.observer) {
          base.observer.unobserve(base);
        }
        base.removeAttribute('loading');
        if (base.button) {
          base.button.classList.add('visually-hidden');
        }
        const endMessage = base.querySelector('.pagination__end-message');
        if (endMessage) endMessage.removeAttribute('hidden');
        return;
      }
      let products = grid_to_replace.querySelectorAll('.column');

      // Capture first newly-appended product so we can scroll to it after
      // the loop. Without this the cursor stays at the load-more button
      // position and shoppers have to scroll back manually to find where
      // the new items begin.
      const firstNewIndex = this.grid.children.length;

      for (var i = 0; i < products.length; i++) {
        this.grid.appendChild(products[i]);
      }

      const firstNew = this.grid.children[firstNewIndex];
      if (firstNew) {
        requestAnimationFrame(() => {
          firstNew.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }

      if (this.animations_enabled) {
        gsap.set(products, {
          opacity: 0,
          y: 30
        });
        gsap.to(products, {
          duration: 0.5,
          y: 0,
          opacity: 1,
          stagger: 0.05,
          onComplete: function() {
            base.removeAttribute('loading');
          }
        });
      } else {
        base.removeAttribute('loading');
      }
    }
  }
  customElements.define('pagination-theme', Pagination);
}